import React from 'react';
import { navigate } from 'gatsby';
import { useSpring, animated } from 'react-spring';
import style from './style.module.scss';
import ButtonPrimary from '../../ButtonPrimary';

const LearnMoreBox = props => {
    const {
        title = 'Box Title',
        backgroundColor = null,
        learnMoreLink = '/',
        image = null,
        imagePosition = "right",
        containerClassName = null,
        imageClassName = null
    } = props;
    const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]

    const trans1 = (x, y) => `translate3d(${x / 50}px,${y / 50}px,0)`
    // const trans2 = (x, y) => `translate3d(${x / 8 + 35}px,${y / 8 - 230}px,0)`
    // const trans3 = (x, y) => `translate3d(${x / 6 - 250}px,${y / 6 - 200}px,0)`
    // const trans4 = (x, y) => `translate3d(${x / 3.5}px,${y / 3.5}px,0)`

    const [springProps, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }))
    return (
        <div
            className={`${style.learnMore} ${containerClassName}`}
            style={{ backgroundColor: backgroundColor }}
            onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}>
            {/* <div
                className={style.imageLayer}
                style={imagePosition === "right" ?
                    { justifyContent: "flex-end", right: '-20px', bottom: "-20px" } :
                    { justifyContent: "flex-start", left: '-20px', bottom: "-20px" }}> */}
            {
                image &&
                // This is where the movement alporithm has to be passed: springProps.xy.interpolate(<ALGORITHM VARIABLE GOES HERE>)
                <animated.div className={style.imageLayer}
                    style={imagePosition === "right" ?
                        { justifyContent: "flex-end", right: '-20px', bottom: "-20px", transform: springProps.xy.interpolate(trans1) } :
                        { justifyContent: "flex-start", left: '-20px', bottom: "-20px", transform: springProps.xy.interpolate(trans1) }}>
                    <img
                        src={image}
                        className={`${style.learnMoreBoxImage} ${imageClassName}`} />
                </animated.div>
            }
            {/* </div> */}
            <div className={style.contentLayer}>
                <span className={style.learnMoreText}>{title}</span>
                <ButtonPrimary
                    label="LEARN MORE"
                    color={backgroundColor}
                    background="#FFFFFF"
                    type="neutral"
                    size="medium"
                    classes={style.learnMoreButton}
                    onClick={() => navigate(learnMoreLink)}>
                </ButtonPrimary>
            </div>
        </div>
    )
};

LearnMoreBox.propTypes = {

};

export default LearnMoreBox;